export default __webpack_public_path__ + "static/media/screen.26ca3c08.png";